import React, { useEffect, useState } from 'react'
import RejectionChartWithoutControls from '../../components/RejectionDoughnut/RejectionChartWithoutControls'
import { showNotification } from '../../utils/toast.utils'
import * as dashboardService from '../../service/dashboard.service'
import StyledSelectField from '../../components/StyledSelectField/StyledSelectField'

const RejectionWrapperMachineWiseUnit4 = ({
  selectedDate,
  machine,
  selectedShift
}) => {
  const defaultPartFamily = {
    value: 'all',
    label: ''
  }
  const [isLoading, setIsLoading] = useState(false)
  const [rejectionData, setRejectionData] = useState({})
  const [selectedPartFamily, setSelectedPartFamily] =
    useState(defaultPartFamily)
  const [availablePartFamilies, setAvailablePartFamilies] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const params = {}

      if (selectedDate) {
        params.date = selectedDate
      }

      try {
        setIsLoading(true)
        const response = await dashboardService.getRejectionDataForDay(params)
        console.log('API Response:', response.data)

        if (response.data.success) {
          const rejectionData = response.data.data.rejectionMachineWiseData
          setRejectionData(rejectionData)

          const partFamilies = new Set()
          Object.keys(rejectionData).forEach((machine) => {
            const machineData = rejectionData[machine]
            Object.keys(machineData).forEach((shift) => {
              Object.keys(machineData[shift]).forEach((partFamily) => {
                partFamilies.add(partFamily)
              })
            })
          })

          const partFamiliesArray = Array.from(partFamilies)
          setAvailablePartFamilies(partFamiliesArray)

          if (partFamiliesArray.length > 0) {
            setSelectedPartFamily({
              value: partFamiliesArray[0],
              label: partFamiliesArray[0]
            })
          } else {
            setSelectedPartFamily(defaultPartFamily)
          }
        } else {
          showNotification(response.data.message, 'error')
        }
      } catch (error) {
        console.error('Error fetching rejection data:', error)
        showNotification('Failed to fetch rejection data', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [selectedDate])

  const machineData =
    machine && machine.value && rejectionData[machine.value]
      ? rejectionData[machine.value]
      : {}

  const shiftData =
    selectedShift && selectedShift.value && machineData[selectedShift.value]
      ? machineData[selectedShift.value]
      : {}

  const filteredShiftData =
    selectedPartFamily.value === 'all'
      ? shiftData
      : shiftData[selectedPartFamily.value]
        ? { [selectedPartFamily.value]: shiftData[selectedPartFamily.value] }
        : {}

  const selectOptions = [
    { value: 'all', label: '' },
    ...availablePartFamilies.map((item) => ({
      label: item,
      value: item
    }))
  ]

  if (isLoading) {
    return <>Loading...</>
  }

  return (
    <>
      {filteredShiftData && Object.keys(filteredShiftData).length > 0 ? (
        <RejectionChartWithoutControls
          rejectionData={filteredShiftData}
          selectionComponent={
            <StyledSelectField
              label=""
              placeHolderText="Select part family"
              selectedValue={selectedPartFamily}
              selectOptions={selectOptions}
              onChangeHandler={(value) => setSelectedPartFamily(value)}
              isMulti={false}
              isSearchable={true}
              isDisabled={false}
              noOptionsMessage="No part family found"
            />
          }
        />
      ) : (
        <p>No data available for the selected machine and shift.</p>
      )}
    </>
  )
}

export default RejectionWrapperMachineWiseUnit4
